import { FETCH_MESSAGE_GROUPS } from "actions"
import { FETCH_MESSAGES_IN_A_GROUP } from "actions"
import { FETCH_MESSAGE_USERS } from "actions";

const initState = {
  groups: [],
  messages: {},
  messageUserGroups: null,
}

export default function (state = initState, action) {
  switch (action.type) {
    case FETCH_MESSAGE_GROUPS:
      return {
        ...state,
        groups: action.payload
      };

    case FETCH_MESSAGES_IN_A_GROUP:
      const { message_group_id, messages } = action.payload;
      return {
        ...state,
        messages: {
          ...state.messages,
          [message_group_id]: messages
        }
      };

    case FETCH_MESSAGE_USERS:
      return {
        ...state,
        messageUserGroups: action.payload
      };

    default:
      return state
  }
}